













































































import { GeekItem } from '@/models';
import { asyncSelectMixin } from '@/shared';
import { Actions, Getters, typedStore } from '@/store';
import { ToastsService } from '@/utils';
import Vue from 'vue';
import Multiselect from 'vue-multiselect';
import mixins from 'vue-typed-mixins';

export default mixins(
  asyncSelectMixin(Actions.opportunities.resetCandidates, Actions.opportunities.fetchCandidates),
).extend({
  name: 'OpportunityAddMember',
  components: {
    Multiselect,
  },
  data() {
    return {
      memberToAdd: null as unknown as GeekItem,
    };
  },
  computed: {
    candidates(): GeekItem[] {
      return typedStore(this).getters[Getters.opportunities.filteredCandidates];
    },
  },
  methods: {
    async addNewMember() {
      try {
        await this.$store.dispatch(Actions.opportunities.addMember, this.memberToAdd);
      } finally {
        ToastsService.success(
          this.$t(
            'opportunities.details.notifications.added-member',
            {
              firstName: this.memberToAdd.firstName,
              nick: this.memberToAdd.nick,
              lastName: this.memberToAdd.lastName,
            },
          ) as string);
        this.memberToAdd = null as unknown as GeekItem;
      }
    },
  },
});
